import './App.css';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Slider from './Slider';
import Header from './Header';
import Footer from './Footer';
import Carts from './Carts';
import Checkout from './Checkout';
import Receipt from './Receipt';
import AboutUs from './AboutUs';
import PrivacyPolicy from './PrivacyPolicy';
import TermsConditions from './TermsConditions';
import Contact from './Contact';
import CartsDetails from './CartsDetails';
import HeaderDown from './HeaderDown';
import SearchResults from './SearchResults';
import BestSells from './BestSells';
import AllToys from './AllToys';
import MoreRecents from './MoreRecents';
import Admin from './Admin';
import BoysToys from './BoysToys';
import GirlsToys from './GirlsToys';
import SignUp from './SignUp';
import SignIn from './SignIn';
import MayWant from './MayWant';
import Search from './Search';
import EditProfile from './EditProfile';
import ChangePassword from './ChangePassword';
import VerifyCode from './VerifyCode';
import Adminn from './Adminn';
import AdProductDetails from './AdProductDetails';
import AdProductEdit from './AdProductEdit';
import AdNewProduct from './AdNewProduct';
import SignInAdmin from './SignInAdmin';
import { useEffect } from 'react';
import axios from 'axios';
import { useStateValue } from './StateProvider';

function App() {
  const [{ basket }, dispatch] = useStateValue();

  useEffect(() => {

    const checkB = localStorage.getItem("bid");
    const checkBasket = JSON.parse(checkB);
    
    if(checkBasket){
      const savedB = localStorage.getItem("basket");
      const savedBasket = JSON.parse(savedB);
      
      savedBasket.map(item => {

        console.log(savedBasket);

        dispatch({
          type: "ADD_TO_BASKET",
          item:{
            id: item.id,
            title: item.title,
            price: item.price,
            img: item.img,
            qnt: item.qnt
          },
        });
      })/**/      
    }else{
      if(basket.length > 0){
        localStorage.setItem("basket", JSON.stringify(basket));
        localStorage.setItem("bid", JSON.stringify(true));
      }else
        localStorage.setItem("bid", JSON.stringify(false));

    }
    

  }, [])

  useEffect(() => {
    const checkB = localStorage.getItem("bid");
    const checkBasket = JSON.parse(checkB);


    if(basket.length > 0){
      localStorage.setItem("basket", JSON.stringify(basket));
      localStorage.setItem("bid", JSON.stringify(true));
    }else
      localStorage.setItem("bid", JSON.stringify(false));
    
    if(basket.length === 0){
      localStorage.removeItem('basket');
      localStorage.setItem("bid", JSON.stringify(false));
    }
    
    
  }, [basket])

  useEffect(() => {
    const saved = localStorage.getItem("usertalking");
    const usertalking = JSON.parse(saved);

    axios
        .get('https://toycityzimbabwe.com/backend/getUsecret.php', {params: { usertalking }} )
        .then(res => {
          getClient(res.data)
        })
        .catch( error => {
            console.log(error)
        });

    const getClient = (clientid) => {
      clientid.map(item => {

        let cid = item.client_id;

        axios
            .get('https://toycityzimbabwe.com/backend/getClient.php', {params: { cid }} )
            .then(res => {
              if(res.data !== ''){
                dispatch({
                  type: 'SET_USER',
                  user: res.data
                })
              }else
                console.log('error')
            })
            .catch( error => {
                console.log(error)
            });
      })
    }

  }, [])

  return (
    <Router>
      <div className="app">
        <Switch>
          <Route path="/admin-new-product">
            <AdNewProduct />
          </Route>
          <Route path="/admin-product-edit">
            <AdProductEdit />
          </Route>
          <Route path="/admin-product-details">
            <AdProductDetails />
          </Route>
          <Route path="/Admin14F-efghS=workApp/filesManagement-Wdf17/Admin">
            <Adminn />
          </Route>
          <Route path="/admin">
            <SignInAdmin />
          </Route>
          <Route path="/signup">
            <SignUp />
          </Route>
          <Route path="/signin">
            <SignIn />
          </Route>
          <Route path="/edit-profile">
            <EditProfile />
          </Route>
          <Route path="/changepassword">
            <ChangePassword />
          </Route>
          <Route path="/changepassword-code-verification">
            <VerifyCode />
          </Route>
          <Route path="/more-recents">
            <Header/>
            <MoreRecents />
            <Footer />
          </Route>
          <Route path="/all-toys">
            <Header/>
            <AllToys />
            <Footer />
          </Route>
          <Route path="/best-sells">
            <Header/>
            <BestSells />
            <Footer />
          </Route>
          <Route path="/boys-toys">
            <Header/>
            <BoysToys />
            <Footer />
          </Route>
          <Route path="/girls-toys">
            <Header/>
            <GirlsToys />
            <Footer />
          </Route>
          <Route path="/search/:search">
            <Header/>
            <SearchResults />
            <Footer />
          </Route>
          <Route path="/details">
            <Header/>
            <CartsDetails />
            <Footer />
          </Route>
          <Route path="/contact">
            <Header/>
            <Contact />
            <Footer />
          </Route>
          <Route path="/terms-and-conditions">
            <Header/>
            <TermsConditions />
            <Footer />
          </Route>
          <Route path="/privacy-policy">
            <Header/>
            <PrivacyPolicy />
            <Footer />
          </Route>
          <Route path="/aboutus">
            <Header/>
            <AboutUs />
            <Footer />
          </Route>
          <Route path="/receipt/">
            <Header/>
            <Receipt />
            <Footer />
          </Route>
          <Route path="/checkout">
            <Header/>
            <Checkout />
            <MayWant />
            <Footer />
          </Route>
          <Route path="/">
            <Header/>
            <HeaderDown/>
            <Search />
            <Slider/>
            <Carts />
            <Footer />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
